import { Phone } from "lucide-react";
import { FaWhatsapp } from "react-icons/fa";
import { Reveal } from "@/components/Reveal";
import { PHONE_DISPLAY, TEL_LINK, waLink, DEFAULT_MSG } from "@/constants/site";

const CtaBand = () => (
  <section className="relative overflow-hidden bg-emergency py-20 sm:py-28 grain" data-testid="cta-band">
    <div className="mx-auto max-w-7xl px-4 sm:px-6 text-center">
      <Reveal>
        <p className="font-mono text-xs tracking-[0.3em] uppercase text-white/80">Stranded right now?</p>
      </Reveal>
      <Reveal delay={0.08}>
        <h2 className="mt-4 font-display text-4xl sm:text-5xl lg:text-7xl font-black uppercase leading-[0.95] text-white">
          We'll be there<br />in no time.
        </h2>
      </Reveal>
      <Reveal delay={0.16}>
        <div className="mt-10 flex flex-col sm:flex-row items-center justify-center gap-4">
          <a
            href={TEL_LINK}
            data-testid="cta-band-call-button"
            className="inline-flex w-full sm:w-auto items-center justify-center gap-2 bg-charcoal px-8 py-4 font-display text-lg font-bold uppercase tracking-wider text-white transition-all duration-300 hover:bg-asphalt hover:-translate-y-0.5"
          >
            <Phone className="h-5 w-5" /> Call {PHONE_DISPLAY}
          </a>
          <a
            href={waLink(DEFAULT_MSG)}
            target="_blank"
            rel="noopener noreferrer"
            data-testid="cta-band-whatsapp-button"
            className="inline-flex w-full sm:w-auto items-center justify-center gap-2 bg-dispatch px-8 py-4 font-display text-lg font-bold uppercase tracking-wider text-white transition-all duration-300 hover:bg-dispatch-dark hover:-translate-y-0.5"
          >
            <FaWhatsapp className="h-5 w-5" /> Text / WhatsApp Us
          </a>
        </div>
      </Reveal>
    </div>
  </section>
);

export default CtaBand;
